var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPicture12(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 211,
    height: 212,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "fx0",
    x: "-10%",
    y: "-10%",
    width: "120%",
    height: "120%",
    filterUnits: "userSpaceOnUse",
    primitiveUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feComponentTransfer", {
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFuncR", {
    type: "discrete",
    tableValues: "0 0"
  }), /*#__PURE__*/React.createElement("feFuncG", {
    type: "discrete",
    tableValues: "0 0"
  }), /*#__PURE__*/React.createElement("feFuncB", {
    type: "discrete",
    tableValues: "0 0"
  }), /*#__PURE__*/React.createElement("feFuncA", {
    type: "linear",
    slope: 0.6,
    intercept: 0
  })), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: "7.63889 7.63889"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1721,
    y: 1493,
    width: 211,
    height: 212
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 1,
    width: 142,
    height: 212
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)",
    transform: "translate(-1721 -1493)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)",
    filter: "url(#fx0)",
    transform: "translate(1720 1492)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M106.5 57.6823C114.062 57.6823 120.25 51.4948 120.25 43.9323 120.25 36.3698 114.062 30.1823 106.5 30.1823 98.9374 30.1823 92.7499 36.3698 92.7499 43.9323 92.7499 51.4948 98.9374 57.6823 106.5 57.6823",
    fill: "#BB8640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.875 109.245 147.75 88.6198 65.2499 88.6198 72.1249 109.245 82.4374 109.245 89.3124 176.276 78.9999 176.276 78.9999 183.151 134 183.151 134 176.276 123.687 176.276 130.562 109.245Z",
    fill: "#BB8640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.344 73.8385C134 72.4635 133.312 71.0885 132.281 70.0573 128.156 66.6198 123.344 64.2135 117.844 62.4948 114.062 61.8073 110.281 61.1198 106.5 61.1198 102.719 61.1198 98.9374 61.8073 95.1561 62.8385 89.6561 64.2135 84.8436 66.9635 80.7186 70.401 79.6874 71.4323 78.9999 72.8073 78.6561 74.1823L76.9374 81.7448 136.234 81.7448 134.344 73.8385Z",
    fill: "#BB8640"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1826.5 1540.52C1834.06 1540.52 1840.25 1534.33 1840.25 1526.77 1840.25 1519.2 1834.06 1513.02 1826.5 1513.02 1818.94 1513.02 1812.75 1519.2 1812.75 1526.77 1812.75 1534.33 1818.94 1540.52 1826.5 1540.52",
    fill: "#BB8640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1860.87 1592.08 1867.75 1571.45 1785.25 1571.45 1792.12 1592.08 1802.44 1592.08 1809.31 1659.11 1799 1659.11 1799 1665.98 1854 1665.98 1854 1659.11 1843.69 1659.11 1850.56 1592.08Z",
    fill: "#BB8640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1854.34 1556.67C1854 1555.3 1853.31 1553.92 1852.28 1552.89 1848.16 1549.45 1843.34 1547.05 1837.84 1545.33 1834.06 1544.64 1830.28 1543.95 1826.5 1543.95 1822.72 1543.95 1818.94 1544.64 1815.16 1545.67 1809.66 1547.05 1804.84 1549.8 1800.72 1553.23 1799.69 1554.27 1799 1555.64 1798.66 1557.02L1796.94 1564.58 1856.23 1564.58 1854.34 1556.67Z",
    fill: "#BB8640"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPicture12);
export default __webpack_public_path__ + "static/media/Picture12.84b7383cafa5c84fbb0359e60508e999.svg";
export { ForwardRef as ReactComponent };